/* empty css                                                       */
import { createElementBlock, nextTick, openBlock, renderSlot } from "vue";
//#region src/components/code_editor/code_editor_input.vue
var _sfc_main = /* @__PURE__ */ Object.assign({ name: "DtcCodeEditorInput" }, {
	emits: ["input"],
	setup(__props, { emit: __emit }) {
		const emit = __emit;
		function getCaretOffset(element) {
			const sel = window.getSelection();
			if (!sel.rangeCount) return 0;
			const range = sel.getRangeAt(0).cloneRange();
			range.selectNodeContents(element);
			range.setEnd(sel.getRangeAt(0).startContainer, sel.getRangeAt(0).startOffset);
			return range.toString().length;
		}
		function setCaretOffset(element, offset) {
			const sel = window.getSelection();
			const range = document.createRange();
			const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
			let currentOffset = 0;
			let node;
			while (node = walker.nextNode()) {
				if (currentOffset + node.textContent.length >= offset) {
					range.setStart(node, offset - currentOffset);
					range.collapse(true);
					sel.removeAllRanges();
					sel.addRange(range);
					return;
				}
				currentOffset += node.textContent.length;
			}
		}
		function onInput(e) {
			const offset = getCaretOffset(e.target);
			emit("input", e);
			nextTick(() => {
				setCaretOffset(e.target, offset);
			});
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("span", {
				class: "dtc-code-editor-input d-ws-pre-wrap",
				spellcheck: "false",
				contenteditable: "",
				onInput
			}, [renderSlot(_ctx.$slots, "default")], 32);
		};
	}
});
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=code_editor_input.vue.js.map